import { createQueryKeyStore } from "@lukemorales/query-key-factory";

import { UseSearchClinicsQueryArgs } from "../hooks/clinic/useSearchClinicsQuery";

export const clinicKeys = createQueryKeyStore({
  clinic: {
    list: null,
    search: (args: UseSearchClinicsQueryArgs) => [args],
    businessHours: (clinicIds: number[]) => ["businessHours", [...clinicIds].sort().join(",")],
    detail: (clinicId: string) => [clinicId],
    byIds: (serializedClinicIds: string) => [serializedClinicIds],
    dates: (clinicId: number, departmentId: number) => [clinicId, departmentId],
  },
});
